import loadable from '@loadable/component';
import './RatingDetail.css';

export default loadable(() => {
  return import('./RatingDetail.jsx');
});
